module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_cocacola_03.e81fed36.jpg";